import Page from "../../components/Page";
import useSpectrumPage from "./hooks/useSpectrumPage";

const SpectrumPage = () => {
  const page = useSpectrumPage();
  return <Page {...page} />;
};

export default SpectrumPage;
